import React from "react"
import { Section } from "./section"

export function SectionBox(props) {
  return (
    <Section>
      <div className="box" style={props.style}>
        {props.children}
      </div>
    </Section>
  )
}
